import { useMutation, useQueryClient } from '@tanstack/react-query';
import ApiConfig from 'src/config/api-config';
import { auth } from 'src/config/firebase';
import { sessionStore } from 'src/store/sessionStore';

export interface AddTrainerClientPayload {
  name: string;
  surname: string;
  email?: string;
  bodyProfile?: string;
}

export const addTrainerClient = async (payload: AddTrainerClientPayload) => {
  const currentUser = sessionStore.getState().currentUser;
  const trainerId = currentUser?.uid || auth.currentUser?.uid;

  if (!trainerId) {
    throw new Error('Trainer ID is missing');
  }

  const apiUrl = `${ApiConfig.CLOUD_FUNCTIONS_BASE_URL}${ApiConfig.TRAINER_ADD_CLIENT}`;

  const response = await fetch(apiUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ ...payload, trainerId }),
  });

  if (!response.ok) {
    let errorMessage = `Failed to add trainer client: ${response.status}`;
    let errorCode = 'ERR_UNKNOWN';
    try {
      const errorData = await response.json();
      if (errorData.errorCode) {
        errorCode = errorData.errorCode;
      }
      if (errorData.error) {
        errorMessage = errorData.error;
      }
    } catch (e) {
      // Ignore json parse error
      console.error('Error adding trainer client', e);
    }
    const error: any = new Error(errorMessage);
    error.errorCode = errorCode;
    throw error;
  }

  return response.json();
};

export function useAddTrainerClient() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: addTrainerClient,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['trainer-clients'] });
    },
  });
}
